module.exports = {
	"id": "DZ",
	"name": "Algeria",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.019221,
			"5": 0.019221,
			"6": 0.012814,
			"7": 0.019221,
			"8": 0.057663,
			"9": null,
			"10": 0.019221,
			"11": 0.070477,
			"12": 0.032035,
			"13": 0.012814,
			"14": 0.025628,
			"15": 0.051256,
			"16": 0.06407,
			"17": 0.025628,
			"18": 0.115326,
			"19": 0.025628,
			"20": 0.032035,
			"21": 0.019221,
			"22": 0.044849,
			"23": 0.032035,
			"24": 0.019221,
			"25": 0.083291,
			"26": 0.070477,
			"27": 0.051256,
			"28": 0.076884,
			"29": 0.083291,
			"30": 0.096105,
			"31": 0.166582,
			"32": 0.076884,
			"33": 0.288315,
			"34": 0.089698,
			"35": 0.044849,
			"36": 0.06407,
			"37": 0.051256,
			"38": 0.108919,
			"39": 0.115326,
			"40": 0.230652,
			"41": 0.057663,
			"42": 0.076884,
			"43": 2.780638,
			"44": 0.12814,
			"45": 0.147361,
			"46": 0.160175,
			"47": 0.217838,
			"48": 0.339571,
			"49": 3.767316,
			"50": 0.326757,
			"51": 1.72989,
			"52": 0.672735,
			"53": 20.874006,
			"54": 6.586396,
			"55": 0.12814,
			"56": 0.076884,
			"57": null
		},
		"firefox": {
			"2": 0.012814,
			"3": 0.070477,
			"4": 0.025628,
			"5": 0.012814,
			"6": 0.012814,
			"7": 0.006407,
			"8": 0.012814,
			"9": 0.019221,
			"10": 0.019221,
			"11": 0.025628,
			"12": 0.057663,
			"13": 0.019221,
			"14": 0.025628,
			"15": 0.038442,
			"16": 0.025628,
			"17": 0.025628,
			"18": 0.019221,
			"19": 0.032035,
			"20": 0.025628,
			"21": 0.025628,
			"22": 0.019221,
			"23": 0.032035,
			"24": 0.025628,
			"25": 0.032035,
			"26": 0.044849,
			"27": 0.032035,
			"28": 0.025628,
			"29": 0.076884,
			"30": 0.089698,
			"31": 0.057663,
			"32": 0.070477,
			"33": 0.089698,
			"34": 0.076884,
			"35": 0.102512,
			"36": 0.089698,
			"37": 0.083291,
			"38": 0.140954,
			"39": 0.096105,
			"40": 0.108919,
			"41": 0.134547,
			"42": 0.102512,
			"43": 0.595851,
			"44": 0.205024,
			"45": 0.230652,
			"46": 0.275501,
			"47": 1.21733,
			"48": 0.83291,
			"49": 6.439035,
			"50": 0.358792,
			"51": 0.032035,
			"52": null,
			"3.5": 0.019221,
			"3.6": 0.12814
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.006407,
			"19": 0.006407,
			"20": 0.006407,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.006407,
			"31": null,
			"32": null,
			"33": 0.006407,
			"34": 0.019221,
			"35": 0.019221,
			"36": 0.160175,
			"37": 0.057663,
			"38": 0.102512,
			"39": 0.076884,
			"40": 1.249365,
			"41": 0.19221,
			"42": 0.012814,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.012814,
			"12.1": 0.070477
		},
		"safari": {
			"0": null,
			"4": 0.012814,
			"5": 0.006407,
			"6": 0.012814,
			"7": 0.019221,
			"8": 0.038442,
			"9": 0.025628,
			"10": 0.102512,
			"3.1": null,
			"3.2": null,
			"5.1": 0.019221,
			"6.1": null,
			"7.1": null,
			"9.1": 0.076884
		},
		"ios_saf": {
			"8": 0,
			"10": 1.03187600333,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0278078642798,
			"8.1-8.4": 0.0513738509575,
			"9.0-9.2": 0.0245086261449,
			"9.3": 0.373913655287
		},
		"android": {
			"3": 0,
			"4": 0.112788449612,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0140985562016,
			"4.1": 0.406844050388,
			"4.2-4.3": 1.01711012597,
			"4.4": 2.33230401163,
			"4.4.3-4.4.4": 2.3524448062
		},
		"ie": {
			"6": 0.027809106383,
			"7": 0.0486659361702,
			"8": 0.660466276596,
			"9": 0.236377404255,
			"10": 0.180759191489,
			"11": 1.13322108511,
			"5.5": null
		},
		"op_mob": {
			"0": 0.129378611919,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00359385033107
		},
		"edge": {
			"12": 0.070477,
			"13": 0.12814,
			"14": 0.12814
		},
		"ie_mob": {
			"10": 0.0970886197183,
			"11": 0.395289380282
		},
		"bb": {
			"7": 0.0098835,
			"10": null
		},
		"samsung": {
			"0": 1.786218
		},
		"and_uc": {
			"0": 1.681992
		},
		"op_mini": {
			"0": 1.74309553775
		},
		"and_chr": {
			"0": 26.305484
		},
		"and_ff": {
			"0": 0.025158
		}
	},
	"total": 97.7197985
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/DZ.json
 ** module id = 511
 ** module chunks = 0
 **/